import React, { useEffect } from 'react';

const Anvandavillkor = () => {
  useEffect(() => {
    document.title = 'Användavillkor';
    document.body.className = 'body-4';
    return () => {
      document.body.className = '';
    };
  }, []);

  return (
    <div className="w-layout-vflex">
      <h1 className="heading-3">Användaravtal</h1>
      <div className="text-block-4">
        <strong>
          ÖVERSIKT
          <br />
        </strong>
        Denna webbplats drivs av TrafikBevakning Sweden. På hela webbplatsen hänvisar termerna,
        &quot;TrafikBevakning&quot;, &quot;vi&quot;, &quot;oss&quot; och &quot;vår&quot; till
        TrafikBevakning Sweden. TrafikBevakning erbjuder denna webbplats, inklusive all information,
        verktyg och tjänster som är tillgängliga från denna webbplats för dig, användaren, under
        förutsättning att du accepterar alla villkor, policyer och meddelanden som anges här.
        <br />
        <br />
        Genom att besöka vår webbplats och/eller köpa något från oss, engagerar du dig i vår
        &quot;Tjänst&quot; och samtycker till att vara bunden av följande villkor
        (&quot;Användarvillkor&quot;, &quot;Villkor&quot;), inklusive dessa ytterligare villkor och
        policyer hänvisas till häri och/eller tillgänglig via hyperlänk. Dessa användarvillkor
        gäller för alla användare av webbplatsen, inklusive utan begränsning användare som är
        webbläsare, leverantörer, kunder, handlare och/eller bidragsgivare till innehåll.
        <br />
        <br />
        Läs dessa användarvillkor noggrant innan du går in på eller använder vår webbplats. Genom
        att gå in på eller använda någon del av webbplatsen samtycker du till att vara bunden av
        dessa användarvillkor. Om du inte godkänner alla villkor och villkor i detta avtal får du
        inte komma åt webbplatsen eller använda några tjänster. Om dessa användarvillkor anses vara
        ett erbjudande är godkännandet uttryckligen begränsat till dessa användarvillkor.
        <br />
        <br />
        Alla nya funktioner eller verktyg som läggs till i den nuvarande butiken ska också omfattas
        av användarvillkoren. Du kan granska den senaste versionen av användarvillkoren när som
        helst på den här sidan. Vi förbehåller oss rätten att uppdatera, ändra eller ersätta någon
        del av dessa användarvillkor genom att publicera uppdateringar och/eller ändringar på vår
        webbplats. Det är ditt ansvar att regelbundet kontrollera denna sida för ändringar. Din
        fortsatta användning av eller åtkomst till webbplatsen efter att ändringar har publicerats
        innebär att du accepterar dessa ändringar.
        <br />
        <br />
        Vår webbplats finns på Vercel. De förser oss med denna plattform online som gör att vi kan
        sälja våra produkter och tjänster till dig.
      </div>
    </div>
  );
};

export default Anvandavillkor;
